
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedLearnerProfile_portfolioProjects"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerProfile_PortfolioProject"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"occupationId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tools"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"businessChallenge"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"linkToWork"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"summary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approach"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dtdId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cmlValue"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"solution"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dtdId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cmlValue"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"challengeAchievement"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentile"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalNumberOfParticipants"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"placement"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastUpdated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"skills"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"estimatedWorkload"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"partner"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logo"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"artifacts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentLink"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assignmentTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"link"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"itemId"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isAutoPublished"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"projectType"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":556}};
    doc.loc.source = {"body":"fragment SharedLearnerProfile_portfolioProjects on LearnerProfile_PortfolioProject {\n  id\n  occupationId\n  tools\n  businessChallenge\n  linkToWork\n  summary\n  approach {\n    dtdId\n    cmlValue\n  }\n  solution {\n    dtdId\n    cmlValue\n  }\n  challengeAchievement {\n    percentile\n    totalNumberOfParticipants\n    placement\n  }\n  completed\n  lastUpdated\n  title\n  slug\n  skills\n  estimatedWorkload\n  image\n  partner {\n    name\n    logo\n  }\n  artifacts {\n    assignmentLink\n    assignmentTitle\n    link\n    type\n    itemId\n  }\n  isAutoPublished\n  projectType\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SharedLearnerProfile_portfolioProjects"] = oneQuery(doc, "SharedLearnerProfile_portfolioProjects");
        
